import React from "react";

import {toast} from "react-toastify";

import ToastNotification from "../components/ToastNotification/ToastNotification";


export const notifyError = (message) => toast.error(<ToastNotification iconName="meh" message={message} />);
export const notifySuccess = (message) => toast.success(<ToastNotification iconName="check" message={message} />);


// WEBPACK FOOTER //
// ./src/toast-notifications/global.js